import { Box } from '@mui/material';
import FollowerChart from 'components/featured/Client/SocialEngagementTab/FollowerChart/FollowerChart';
import MonthlyBarChart from 'components/featured/Client/SocialEngagementTab/MonthlyBarChart/MonthlyBarChart';
import SocialAccounts from 'components/featured/Client/SocialEngagementTab/SocialAccounts/SocialAccounts';
import React, { useEffect, useState } from 'react';
import { ClientService } from 'service/client.service';
import { useAppSelector } from 'store/hooks';

const Captiv8Chart = ({
  socialEngagement,
  loading,
  error,
}: {
  socialEngagement: any;
  loading: boolean;
  error: string | null;
}) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gridTemplateRows: 'auto auto',
        gap: { xs: '12px', xl: '24px' },
      }}
    >
      <SocialAccounts loading={false} data={socialEngagement?.socialAccounts} />
      <FollowerChart data={socialEngagement?.followers} loading={false} />
      <MonthlyBarChart
        title='Monthly Engagement'
        total={socialEngagement?.monthlyEngagement?.formattedTotal}
        percent={socialEngagement?.monthlyEngagement?.changePercent}
        data={socialEngagement?.monthlyEngagement}
        chartKey='engagement'
        loading={false}
      />
      <MonthlyBarChart
        title='Monthly Average Views'
        total={socialEngagement?.monthlyViews?.formattedTotal}
        percent={socialEngagement?.monthlyViews?.changePercent}
        data={socialEngagement?.monthlyViews}
        chartKey='avgViews'
        loading={false}
      />
    </Box>
  );
};

export default Captiv8Chart;
